import { loadPaginationActions } from '@coveo/headless-react/ssr';

type PaginationEngine = Parameters<typeof loadPaginationActions>[0];

/**
 * Make `numberOfResults` the pagination default on the engine so the
 * SearchParameterManager omits it from serialized URLs (it only includes
 * `numberOfResults` when it differs from the default). Page size is a personal
 * preference persisted in localStorage, not a shareable URL parameter.
 * registerNumberOfResults is a pure Redux state action; it dispatches no
 * search.
 */
export function registerNumberOfResultsAsDefault(
  engine: PaginationEngine | undefined,
  numberOfResults: number
): void {
  if (!engine) return;
  engine.dispatch(
    loadPaginationActions(engine).registerNumberOfResults(numberOfResults)
  );
}
